import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { SpaceXs } from "@nxt-costco-com/forge-design-tokens";
import { CustomSingleSkeleton } from "../CustomSingleSkeleton/CustomSingleSkeleton.js";
import { COMPONENT_NAME, RADIO_BUTTON_CIRCLE_SIZE, BORDER_RADIUS_CIRCLE, RADIO_BUTTON_CIRCLE_ID, RADIO_BUTTON_LABEL_HEIGHT, RADIO_BUTTON_LABEL_ID } from "../constants.js";
import { SkeletonVariant } from "../enums.js";
const RadioButtonSkeleton = ({
  hiddenText,
  width
}) => {
  const widthValue = width ?? "100%";
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        gap: SpaceXs,
        width: widthValue
      },
      "data-testid": COMPONENT_NAME,
      children: [
        /* @__PURE__ */ jsx(
          CustomSingleSkeleton,
          {
            "data-testid": RADIO_BUTTON_CIRCLE_ID,
            height: RADIO_BUTTON_CIRCLE_SIZE,
            hiddenText,
            sx: {
              borderRadius: BORDER_RADIUS_CIRCLE,
              flex: "none"
            },
            variant: SkeletonVariant.Rectangular,
            width: RADIO_BUTTON_CIRCLE_SIZE
          }
        ),
        /* @__PURE__ */ jsx(
          CustomSingleSkeleton,
          {
            "data-testid": RADIO_BUTTON_LABEL_ID,
            height: RADIO_BUTTON_LABEL_HEIGHT,
            hiddenText,
            sx: {
              borderRadius: BORDER_RADIUS_CIRCLE
            },
            variant: SkeletonVariant.Rectangular,
            width: "100%"
          }
        )
      ]
    }
  );
};
export {
  RadioButtonSkeleton
};
